import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAzureServicesDayMeasures } from "./finops-azure-services.model";
import { DateGranularityEnum } from "src/app/shared/enum/date-granularity.enum";

@Injectable({
    providedIn: 'root'
})
export class FinOpsAzureServicesService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
    ) {
    }

    loadFinOpsAzureServicesHistoricalData(granularity: DateGranularityEnum, subscriptionId: string, date: string) {
        return this.httpClient.get<FinOpsAzureServicesDayMeasures>(`${this.configService.config.apiUrl}/finops/azure/services?date=${date}&granularity=${granularity}&subscription=${subscriptionId}`)
    }

    loadFinOpsAzureServicesMeasures(date: string, subscriptionId: string) {
        return this.httpClient.get<FinOpsAzureServicesDayMeasures>(`${this.configService.config.apiUrl}/finops/azure/services/measures?date=${date}&subscription=${subscriptionId}`)
    }
}
